export default class CaseStudyTimeline {
    static init(): void {
        this.moveTimelineToPlaceholder();
    }

    private static moveTimelineToPlaceholder(): void {
        // Najdeme placeholder element vložený adminem
        const placeholder = document.querySelector('.timeline-placeholder');

        // Najdeme původní timeline element (který je skrytý)
        const timelineWrapper = document.querySelector('.implement-section__timeline');

        if (placeholder && timelineWrapper) {
            // Přesuneme timeline na místo placeholderu
            placeholder.replaceWith(timelineWrapper);

            // Odstraníme třídu 'none', aby byla časová osa viditelná
            timelineWrapper.classList.remove('none');
        }
    }
}
